import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ConfigItemProps } from "apis";

export type ConfigState = ConfigItemProps;

const initialState: ConfigState = {
    logoUrl: "",
    title: "Bệnh viện đa khoa",
    subTitle: null,

    bannerUrls: [],

    hotline: null,
    address: null,
    phone: null,
    fax: null,
    email: null
};
export const configSlice = createSlice({
    name: "config",
    initialState,
    reducers: {
        configUpdate: (
            state,
            action: PayloadAction<ConfigState>
        ) => {
            state.address = action.payload.address;
            state.bannerUrls = action.payload.bannerUrls;
            state.email = action.payload.email;
            state.fax = action.payload.fax;
            state.hotline = action.payload.hotline;
            state.logoUrl = action.payload.logoUrl;
            state.phone = action.payload.phone;
            state.subTitle = action.payload.subTitle;
            state.title = action.payload.title;
            state.copyright = action.payload.copyright;
            state.businessHours = action.payload.businessHours;
            state.googleMapUrl = action.payload.googleMapUrl;
            state.organizationalStructureString = action.payload.organizationalStructureString;
            state.organizationalStructure = action.payload.organizationalStructure;
            state.editorUploadFolderId = action.payload.editorUploadFolderId;
            state.linkEmail = action.payload.linkEmail;
            state.linkFacebook = action.payload.linkFacebook;
            state.linkZalo = action.payload.linkZalo;
            state.slogan = action.payload.slogan;
            state.subSlogan = action.payload.subSlogan;
        }
    },
});

export const { configUpdate } = configSlice.actions;
export default configSlice.reducer;
